<div
  class="otp-input-container font-work-sans font-regular w-[38rem]"
>
  <mat-form-field
    *ngFor="let item of otpLooperArr; let last = last"
    class="form-field w-[5.8rem] flex flex-row"
    [ngClass]="{
        'mr-[1.6%]': !last,
        'mr-0': last
      }"
    appearance="outline"
    hideRequiredMarker
  >
    <input
      #input
      [id]="'otp-'+item"
      class="input number-input text-center"
      [class.text-black-400]="isDisabled"
      matInput
      placeholder="{{placeholder}}"
      type="text"
      max="9"
      min="0"
      data-index="{{item}}"
      [(ngModel)]="otpValue[item]"
      inputmode="numeric"
    >
  </mat-form-field>
  <mat-error *ngIf="error">{{error}}</mat-error>
</div>
